var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13.333,
  height: 13.333,
  viewBox: "0 0 13.333 13.333"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon_feather-download",
  "data-name": "Icon feather-download",
  transform: "translate(-1.333 -1.333)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  d: "M14,10v2.667A1.333,1.333,0,0,1,12.667,14H3.333A1.333,1.333,0,0,1,2,12.667V10",
  fill: "none",
  stroke: "#1370fb",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M4.667,6.667,8,10l3.333-3.333",
  fill: "none",
  stroke: "#1370fb",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  d: "M8,10V2",
  fill: "none",
  stroke: "#1370fb",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333
}))));
export default __webpack_public_path__ + "static/media/download_new.62a5f2e1.svg";
export { SvgComponent as ReactComponent };